import { useForm } from '@mantine/form';
import { Button, Group, TextInput, Modal } from '@mantine/core';
import { AppContext } from '../../../context/context';
import { useContext, useEffect, useState } from 'react';
import { showNotification } from '@mantine/notifications';

const FormInfo = ({ id }) => {

  const appcontext = useContext(AppContext);

  useEffect(() => {
    if (id != '' && appcontext.openedFNI) {
      getDataFromId(id);
    }
  }, [appcontext.openedFNI]);

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      COMPLETEDOCS: '',
      CODEDESV: '',
      LASTUPDATE: '',
      IC: '',
      VUELOMEX: '',
      FECHACONEXION: '',
      LLEGADAPTOCNX: '',
      DIACONEXION: '',
      TIEMPOCONEXION: '',
      OBSERVACIONES: '',
    },
  });

  const getDataFromId = async (id) => {
    try {
      const response = await fetch(process.env.REACT_APP_API_URL_DE + '/api/interlineales/extrainfo/' + id, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem("token")}`,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      let result = await response.json();
      form.setValues({
        COMPLETEDOCS: result.completeDocuments,
        CODEDESV: result.codeDesviation,
        LASTUPDATE: result.FECHA_ACTUALIZACION.substring(0, 10) + ' ' + result.USUARIO_ACTUALIZACION,
        IC: result.interline,
        VUELOMEX: result.vueloMex || '',
        FECHACONEXION: result.fechaConexion || '',
        LLEGADAPTOCNX: result.llegadaPuntoCnx || '',
        DIACONEXION: result.diaConexion || '',
        TIEMPOCONEXION: result.tiempoConexion || '',
        OBSERVACIONES: result.observaciones || ''
      });
    } catch (err) {
      showNotification({
        title: 'Error!',
        message: err.response?.data?.error ? err.response.data.error : err.message,
        color: '#fff',
        styles: (theme) => ({
          root: {
            backgroundColor: '#E93F19',
            borderColor: 'E93F19',
            '&::before': { backgroundColor: theme.white },
          },
          title: { color: theme.white },
          description: { color: theme.white },
          closeButton: {
            color: theme.white,
          },
        }),
        autoClose: false,
      })
    }
  }

  return (
    <Modal opened={appcontext.openedFNI} onClose={() => { appcontext.setStatusFNI(false); }} title="Informacion">
      <form>
        <TextInput
          label="COMPELETE DOCS"
          readOnly
          key={form.key('COMPLETEDOCS')}
          {...form.getInputProps('COMPLETEDOCS')}
        />
        <TextInput
          label="CODE DESVIATION"
          mt="md"
          readOnly
          key={form.key('CODEDESV')}
          {...form.getInputProps('CODEDESV')}
        />
        <TextInput
          label="LAST UPDATE"
          mt="md"
          readOnly
          key={form.key('LASTUPDATE')}
          {...form.getInputProps('LASTUPDATE')}
        />
        <TextInput
          label="INTERLINE CONEXION"
          mt="md"
          readOnly
          key={form.key('IC')}
          {...form.getInputProps('IC')}
        />
        <TextInput
          label="VUELO MEX"
          mt="md"
          readOnly
          key={form.key('VUELOMEX')}
          {...form.getInputProps('VUELOMEX')}
        />
        <TextInput
          label="FECHA DE CONEXIÓN"
          mt="md"
          readOnly
          key={form.key('FECHACONEXION')}
          {...form.getInputProps('FECHACONEXION')}
        />
        <TextInput
          label="LLEGADA A PUNTO DE CNX"
          mt="md"
          readOnly
          key={form.key('LLEGADAPTOCNX')}
          {...form.getInputProps('LLEGADAPTOCNX')}
        />
        <TextInput
          label="DÍA DE CONEXIÓN"
          mt="md"
          readOnly
          key={form.key('DIACONEXION')}
          {...form.getInputProps('DIACONEXION')}
        />
        <TextInput
          label="TIEMPO EN CONEXIÓN"
          mt="md"
          readOnly
          key={form.key('TIEMPOCONEXION')}
          {...form.getInputProps('TIEMPOCONEXION')}
        />
        <TextInput
          label="OBSERVACIONES"
          mt="md"
          readOnly
          key={form.key('OBSERVACIONES')}
          {...form.getInputProps('OBSERVACIONES')}
        />
        <Group justify="flex-end" mt="md">
          <Button type="button" variant='outline' onClick={() => { appcontext.setStatusFNI(false); }}>Cerrar</Button>
        </Group>
      </form>
    </Modal>
  );

}

export default FormInfo;